import PropTypes from 'prop-types'
import React from 'react'

import Button from '@material-ui/core/Button'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'

export default function ControlButton(props) {
  const { Icon, label, ...buttonProps } = props

  const theme = useTheme()

  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const displayLabel = !smallScreen && label

  /* eslint-disable react/jsx-props-no-spreading */
  return (
    <Button startIcon={displayLabel && <Icon />} size="small" {...buttonProps}>
      {displayLabel && label}
      {!displayLabel && <Icon />}
    </Button>
  )
  /* eslint-enable react/jsx-props-no-spreading */
}

ControlButton.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  label: PropTypes.string,
}
